import { IOffer } from '../../../../types/offer';

export function getClientFee(offer: IOffer): string {
  const fee = offer.bargainTerms.clientFee ? `комиссия ${offer.bargainTerms.clientFee}%` : 'без комиссии';

  return fee;
}
